import PropTypes from 'prop-types';
import React from 'react';

import { Trans } from 'react-i18next';
import { Table, Modal, Button, Select, Input, Icon } from 'semantic-ui-react';

export const LANGUAGES = {
    fr: 'Français (FR)',
    'fr-fr': 'Français (FR)',
    'fr-ca': 'Français (CA)',
    'en-gb': 'English (GB)',
    'en-ca': 'English (CA)',
    'en-us': 'English (US)',
    'es-es': 'Español (ES)',
    'ca-es': 'Español (CA)',
    it: 'Italiano (IT)',
    'it-it': 'Italiano (IT)',
    br: 'Breton (FR-BRE)',
    'nl-nl': 'Nederlands (NL)',
    'de-ch': 'Deutsch (CH)',
    'de-de': 'Deutsch (DE)',
    eu: 'Basque (EU)',
    'ru-ru': 'Русский (RU)',
    'pt-pt': 'Português (PT)',
    'el-gr': 'Ελληνικά (EL)',
    'tr-tr': 'Türkçe (TR)'
};

export default class TranslationsModal extends React.Component {
    constructor() {
        super(...arguments);

        let { defaultLanguage, translations } = this.props;

        if (!Object.keys(translations).length) {
            // TODO: Get orga default language
            translations = [
                {
                    [defaultLanguage]: ''
                }
            ];
        }

        const translationsState = Object.entries(this.props.translations).map(([key, value], index) => {
            return {
                lang: key,
                translation: value,
                index
            };
        });

        this.state = {
            translations: translationsState
        };
    }

    getTranslations() {
        return this.state.translations.reduce((obj, { lang, translation }) => {
            if (translation) {
                obj[lang] = translation;
            }
            return obj;
        }, {});
    }

    getLanguageOptions() {
        return Object.entries(LANGUAGES).map(([key, value]) => ({
            text: value,
            value: key
        }));
    }

    setTranslation(index, prop, value) {
        let translationIndex = this.state.translations.findIndex(item => item.index === index);
        if (translationIndex < 0) {
            return;
        }

        let translationState = this.state.translations[index];
        translationState[prop] = value;

        let newTranslations = this.state.translations.slice(0);
        newTranslations.splice(index, 1, translationState);
        this.setState({
            translations: newTranslations
        });
    }

    deleteTranslation(index) {
        let newTranslations = this.state.translations.slice(0);
        let translationIndex = newTranslations.findIndex(item => item.index === index);
        newTranslations.splice(translationIndex, 1);
        this.setState({
            translations: newTranslations
        });
    }

    renderTranslation({ lang, translation, index }) {
        return (
            <Table.Row>
                <Table.Cell>
                    <Select value={lang} placeholder="Language" options={this.getLanguageOptions()} onChange={(synth, { value }) => this.setTranslation(index, 'lang', value)} />
                </Table.Cell>
                <Table.Cell>
                    <Input value={translation} placeholder={'...'} onChange={(synth, { value }) => this.setTranslation(index, 'translation', value)} />
                    <Icon name="delete" style={{ float: 'right', 'padding-top': '10px' }} onClick={() => this.deleteTranslation(index)} />
                </Table.Cell>
            </Table.Row>
        );
    }

    render() {
        return (
            <Modal open={this.props.open ?? true}>
                <Modal.Header>
                    <Trans i18nKey="ticket.chart.translation_plural">Translations</Trans>
                </Modal.Header>
                <Modal.Content scrolling>
                    <Table celled padded unstackable>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>
                                    <Trans i18nKey="ticket.chart.language">Language</Trans>
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan="2">
                                    <Trans i18nKey="ticket.chart.translation">Translation</Trans>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>{this.state.translations.map(translation => this.renderTranslation(translation))}</Table.Body>
                    </Table>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        primary
                        floated="left"
                        onClick={() => {
                            let { translations } = this.state;
                            translations.push({
                                lang: null,
                                translation: '',
                                index: translations.length
                            });
                            this.setState({ translations });
                        }}
                    >
                        <Trans i18nKey="ticket.common.action.add">+ Translation</Trans>
                    </Button>
                    <Button onClick={() => this.props.onClose()}>
                        <Trans i18nKey="ticket.common.action.cancel">Return</Trans>
                    </Button>
                    <Button primary onClick={() => this.props.onSubmit(this.getTranslations())}>
                        <Trans i18nKey="ticket.common.action.validate">Validate</Trans> <Icon name="chevron right" />
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

TranslationsModal.defaultProps = {
    defaultLanguage: 'fr-fr'
};

TranslationsModal.propTypes = {
    translations: PropTypes.object,
    defaultLanguage: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool
};
